import baseUrl from "constants/baseUrl";

export const uploadImage = async (file, folder)=>{
    const formData = new FormData();
    formData.append("image", file);
    const result = await fetch(`${baseUrl}/image/upload-image?folder=${folder}`,
    {
      method:"POST",
      body: formData,
      headers:{
        // "Content-Type": 'multipart/form-data'
      },
      credentials: "include"
    })
    const resultData = await result.json();
    return {
      "success": 1,
      "file": {
        "url": `${baseUrl}${resultData.data.url}`
      }
    }
}

export const deleteImage = async (name, folder)=>{
  const result = await fetch(`${baseUrl}/image/delete-image?name=${name}&folder=${folder}`,
  {
    method:"DELETE",
    credentials: "include"
  })
  const resultData = await result.json();
  return resultData;
}